import type { ReactNode } from 'react';

/**
 * A unit suffix inside a numeric field (spec §12.6: units are suffixes). The
 * field's label carries the unit for screen readers (an sr-only "(m)"); the
 * suffix is visual only. Give the input enough right padding (`pr-10` for
 * "m", `pr-12` for "mm").
 */
export function UnitSuffix({ unit, testId, children }: { unit: string; testId?: string; children: ReactNode }) {
  return (
    <div className='relative min-w-0'>
      {children}
      <span
        aria-hidden
        data-testid={testId}
        className='pointer-events-none absolute inset-y-0 right-3 flex items-center text-xs text-muted-foreground'>
        {unit}
      </span>
    </div>
  );
}

/** The sr-only unit for a field label: "Grid size (m)" to a screen reader. */
export function SrUnit({ unit }: { unit: string }) {
  return <span className='sr-only'> ({unit})</span>;
}
